module.exports = __webpack_public_path__ + "static/img/technology3.29672f96.png";